export const SIMPLE = { id: 'simple', label: 'Semplice' };
export const MULTIPLE = { id: 'multiple', label: 'Plurimo' };
